import { DATE_FORMATS } from '../inputPatterns/date/formats';
import { FORMAT_PATTERNS } from '../inputPatterns/date/formatLabel';
import { LOCALES, LocaleType } from './localeConstants';

const {
  MM_DD_YYYY,
  DD_MM_YYYY,
  MM_YYYY,
  MMM_DD_YYYY_COMMA,
  MMM_DD_YYYY,
  DD_MMM_YYYY,
  DD_MMM_YYYY_COMMA,
  MMM_YYYY,
  MMMM_DD_YYYY,
  MMMM_DD_YYYY_COMMA,
  DD_MMMM_YYYY,
  DD_MMMM_YYYY_COMMA,
  MMMM_YYYY,
  YYYY_MM_DD,
} = FORMAT_PATTERNS;
export const SUPPORTED_FORMATS_BY_LOCALE: Record<string, { regex: RegExp; label: string }[]> = {
  [LOCALES.EN_US]: [
    // US date formats with numeric month and numeric day
    DATE_FORMATS[MM_DD_YYYY],
    // month year formats
    DATE_FORMATS[MM_YYYY],
    DATE_FORMATS[MMM_YYYY],
    DATE_FORMATS[MMMM_YYYY],
    // Short month formats with day
    DATE_FORMATS[DD_MMM_YYYY],
    DATE_FORMATS[DD_MMM_YYYY_COMMA],
    DATE_FORMATS[MMM_DD_YYYY],
    DATE_FORMATS[MMM_DD_YYYY_COMMA],
    // Full month formats with day
    DATE_FORMATS[DD_MMMM_YYYY],
    DATE_FORMATS[DD_MMMM_YYYY_COMMA],
    DATE_FORMATS[MMMM_DD_YYYY],
    DATE_FORMATS[MMMM_DD_YYYY_COMMA],
    // year month date format
    DATE_FORMATS[YYYY_MM_DD],
  ],
  [LOCALES.EN_GB]: [
    // International date formats with numeric month and numeric day
    DATE_FORMATS[DD_MM_YYYY],
    // month year formats
    DATE_FORMATS[MM_YYYY],
    DATE_FORMATS[MMM_YYYY],
    DATE_FORMATS[MMMM_YYYY],
    // Short month formats with day
    DATE_FORMATS[DD_MMM_YYYY],
    DATE_FORMATS[DD_MMM_YYYY_COMMA],
    DATE_FORMATS[MMM_DD_YYYY],
    DATE_FORMATS[MMM_DD_YYYY_COMMA],
    // Full month formats with day
    DATE_FORMATS[DD_MMMM_YYYY],
    DATE_FORMATS[DD_MMMM_YYYY_COMMA],
    DATE_FORMATS[MMMM_DD_YYYY],
    DATE_FORMATS[MMMM_DD_YYYY_COMMA],
    // year month date format
    DATE_FORMATS[YYYY_MM_DD],
  ],
};

export const monthAliasOverrides: Record<LocaleType, Record<string, number>> = {
  [LOCALES.EN_GB]: {
    sep: 8, // "Sep" valid in en-GB, even though "Sept" is the official short form
  },
  [LOCALES.EN_US]: {
    sept: 8, // Accept "Sept" even though "Sep" is default
  },
};
